import { handleActions } from 'redux-actions'
import * as formsActions from '../actions'

export default handleActions(
  {
    [formsActions.openSwitchFormDialog.toString()](state, action) {
      return true
    },
    [formsActions.closeSwitchFormDialog.toString()](state, action) {
      return false
    },
    [formsActions.resetFormsState.toString()](state, action) {
      return false
    },
  },
  false
)
